module.exports = {"440305001":"南头街道","440305002":"南山街道","440305003":"沙河街道","440305005":"蛇口街道","440305006":"招商街道","440305007":"粤海街道","440305008":"桃源街道","440305009":"西丽街道","440305400":"前海合作区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440305.json
// module id = 1968
// module chunks = 0